import ApiService from '@/services/core/api.service'

const UnsuccessfulReasonService = {
  async get (query) {
    return ApiService.get(`supervisor/unsuccessful-reasons?${query}`)
  },

  async post (payload) {
    return ApiService.post('supervisor/unsuccessful-reasons', payload)
  },

  async put (payload) {
    return ApiService.put(`supervisor/unsuccessful-reasons/${payload.id}`, payload)
  }
}

export default UnsuccessfulReasonService
